module.exports = __webpack_public_path__ + "51652747cb55402538c21e4a4a4c2186.svg";